import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const TagManagerRoot = () => {
  useEffect(() => TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY! }), []);

  return <></>;
};
